export default "__VITE_ASSET__XURzvpvN__"